import { checkboxClasses } from "@mui/material";
import { deepPurple, green, orange, red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

const palette = {
  primary: {
    50: "#FDE7E6",
    100: "#FFC8B9",
    200: "#FFA38D",
    300: "#FF7D5F",
    400: "#FF5D3D",
    500: "#FF371B",
    600: "#FC3117",
    700: "#EE2911",
    800: "#E01F0C",
    900: "#C80000",
    A100: "#FFA38D",
    A200: "#FF5D3D",
    A400: "#FF371B",
    A700: "#FC3117",
  },
  neutral: {
    50: "#F8F8F8",
    100: "#F1F1F1",
    200: "#E7E7E7",
    300: "#D6D6D6",
    400: "#B2B2B2",
    500: "#929292",
    600: "#6A6A6A",
    700: "#575757",
    800: "#383838",
    900: "#181818",
    A100: "#E7E7E7",
    A200: "#B2B2B2",
    A400: "#181818",
    A700: "#383838",
  },
  white: "#FFFFFF",
  green: green,
};

const color = {
  ...palette,
};

const spacing = {
  xxs: "1px",
  xs: "2px",
  s: "4px",
  m: "8px",
  mx: "12px",
  l: "16px",
  lx: "20px",
  lxx: "24px",
  xl: "32px",
  xxl: "40px",
  xxxl: "44px",
  xxxxl: "48px",
  xxxxxl: "56px",
};

const deviceWidth = {
  mobile: "500px",
  tablet: "945px",
  laptop: "1024px",
  desktop: "2560px",
};

const lineHeight = {
  s: "18px",
  m: "24px",
  l: "30px",
  xl: "40px",
};

const zIndex = {
  low: "1",
  medium: "100",
  high: "999",
  veryHigh: "2000",
  superHigh: "10000",
};

const borderRadius = {
  xs: "6px",
  m: "8px",
  l: "16px",
  lx: "24px",
  xl: "32px",
};

const font = {
  regular: "Inter",
};

const fontSize = {
  body12: "12px",
  body14: "14px",
  body15: "15px",
  body16: "16px",
};

const shadowBox = {
  style1: "0px 0px 32px 0px #0000001f",
  style2: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;",
};

export const mui = createTheme({
  palette: {
    primary: { 500: color.primary[900] },
    secondary: { ...color.neutral },
    text: {
      primary: color.neutral[900],
      secondary: color.neutral[700],
      disabled: color.neutral[400],
    },
    success: green,
    warning: orange,
    error: { ...red, 500: "#D32F2F" },
    info: deepPurple,
  },
  typography: {
    body1: {
      fontFamily: font.regular,
      fontSize: 14,
    },
    button: {
      textTransform: "none",
      fontFamily: font.regular,
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: color.neutral[900],
          [`&.${checkboxClasses.checked}`]: {
            color: color.neutral[900],
          },
        },
      },
    },
  },
});

export const theme = {
  color,
  spacing,
  deviceWidth,
  font,
  fontSize,
  lineHeight,
  zIndex,
  borderRadius,
  mui,
  shadowBox,
};
